/** Production gym gallery defaults shared by every profile until customized. */

export type DefaultGalleryItem = {
  id: string;
  kind: 'asset' | 'video';
  caption: string;
  alt: string;
  position: number;
  assetKey?: string;
  imagePath?: string;
  videoUrl?: string;
  credit?: string;
};

export const DEFAULT_GYM_GALLERY: readonly DefaultGalleryItem[] = Object.freeze([
  {
    id: 'a1000000-0000-4000-8000-000000000001',
    kind: 'asset',
    assetKey: 'rack',
    imagePath: '/images/gym-samples/gym-sample-rack.webp',
    caption: 'Morning on the rack',
    alt: 'A charcoal power rack and barbell in a home garage, with morning light from an open door.',
    position: 0,
  },
  {
    id: 'a1000000-0000-4000-8000-000000000002',
    kind: 'video',
    videoUrl: 'https://www.youtube.com/watch?v=NgvpmxPfR9c',
    caption: 'Budget home gym tour',
    alt: 'Budget home gym tour of an affordable garage gym by Ronnie Sarmiento.',
    credit: 'YouTube · Ronnie Sarmiento',
    position: 1,
  },
  {
    id: 'a1000000-0000-4000-8000-000000000003',
    kind: 'asset',
    assetKey: 'dumbbells',
    imagePath: '/images/gym-samples/gym-sample-dumbbells.webp',
    caption: 'The dumbbell corner',
    alt: 'Hex dumbbells on a low shelf against a block wall in a home gym.',
    position: 2,
  },
  {
    id: 'a1000000-0000-4000-8000-000000000004',
    kind: 'asset',
    assetKey: 'floor',
    imagePath: '/images/gym-samples/gym-sample-floor.webp',
    caption: 'Floor work',
    alt: 'Kettlebells and a jump rope on black rubber flooring.',
    position: 3,
  },
  {
    id: 'a1000000-0000-4000-8000-000000000005',
    kind: 'asset',
    assetKey: 'bench',
    imagePath: '/images/gym-samples/gym-sample-bench.webp',
    caption: 'Bench and plates',
    alt: 'A black adjustable bench beside a plate tree in a garage gym.',
    position: 4,
  },
  {
    id: 'a1000000-0000-4000-8000-000000000006',
    kind: 'asset',
    assetKey: 'barbell',
    imagePath: '/images/gym-samples/gym-sample-barbell.webp',
    caption: 'After hours',
    alt: 'A loaded barbell on the floor of a home gym at night.',
    position: 5,
  },
  {
    id: 'a1000000-0000-4000-8000-000000000007',
    kind: 'video',
    videoUrl: 'https://www.youtube.com/watch?v=UnIjDWlxDro',
    caption: 'Dream garage gym',
    alt: 'Jordan Pulmano touring the garage home gym he built.',
    credit: 'YouTube · Jordan Pulmano',
    position: 6,
  },
  {
    id: 'a1000000-0000-4000-8000-000000000008',
    kind: 'asset',
    assetKey: 'door',
    imagePath: '/images/gym-samples/gym-sample-door.webp',
    caption: 'Toward the door',
    alt: 'A rowing machine facing an open garage door and trees outside.',
    position: 7,
  },
]);
